import React, { useState, useCallback, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useOnSelectionChange, useReactFlow } from '@xyflow/react';
import { NODE_TYPES } from '../constant';
import SbcTextfield from './SbcTextfield';
import SbcDropdown from './SbcDropdown';
import SbcCalendar from './SbcCalendar';
import SharedDialog from '../../common/dialog/SharedDialog';
import { Button, Grid, Stack, TextField } from '@mui/material';
import SbcRadio from './SbcRadio';
import SbcCheckbox from './SbcCheckbox';
import SbcRating from './SbcRating';
import SbcImagelist from './SbcImagelist';
import SbcDropdownTextfield from './SbcDropdownTextfield';
import { setSurveyFlow } from '../../../actions/surveyFlowAction';
import { LANGS_WITHOUT_TW } from '../../../Constants/lang';

const LANGS = LANGS_WITHOUT_TW

export default function Sidebar() {

    const dispatch = useDispatch()
    const savedSurveyFlow = useSelector(state => state.surveyFlow.ui.surveyFlow)

    const [open, setOpen] = useState(false)
    const [openCreateOptionDialog, setOpenCreateOptionDialog] = useState(false)
    const [createOptionData, setCreateOptionData] = useState({
        key: '',
        value: {
            'EN': '',
            'ZH_CN': '',
            'ZH_HK': ''
        }
    })
    const [errMsg, setErrMsg] = useState('')
    const [node, setNode] = useState(null)

    const flowContainer = useRef()

    const { updateNode, getEdges, setEdges } = useReactFlow()

    const onChange = useCallback(({ nodes, edges }) => {
        setNode(nodes?.[0])

        if (nodes?.length >= 1) setOpen(true)
        else setOpen(false)
    }, []);

    // @FIXME only update node/edge data when nodes onSelect， need to change on every node/edge data chagne
    useOnSelectionChange({
        onChange,
    });

    const handleClose = () => setOpen(false)

    const onDragStart = (event, nodeType) => {
        event.dataTransfer.setData('application/reactflow', nodeType);
        event.dataTransfer.effectAllowed = 'move';
    };

    const handleInputChange = (e) => {
        setNode(n => ({ ...n, data: { ...n?.data, [e.target.name]: e.target.value } }))
    }

    const handleMultiInputChange = (e) => {
        if (e.target.dataset?.itemKeyName) {
            setNode(n => ({ ...n, data: { ...n?.data, [e.target.dataset?.keyName]: n?.data?.[e.target.dataset?.keyName]?.map(i => i?.key === e.target.dataset?.itemKeyName ? ({ ...i, value: { ...i?.value, [e.target.name]: e.target.value } }) : i) } }))
        } else {
            setNode(n => ({ ...n, data: { ...n?.data, [e.target.dataset?.keyName]: { ...n?.data?.[e.target.dataset?.keyName], [e.target.name]: e.target.value } } }))
        }
    }

    const handleSwitchChange = (e, value) => {
        if (e.target.name == 'optionsNode') {
            if (value) {
                const currEdges = getEdges()
                const restEdges = currEdges.filter(edge => node?.data?.id !== edge?.source)
                setEdges(restEdges)
            } else {
                const currEdges = getEdges()
                const currOptionsId = node?.data?.['answerOptionList']?.map(op => op?.key)?.filter(i => i)
                const restEdges = currEdges.filter(edge => !currOptionsId?.includes(edge?.sourceHandle))
                setEdges(restEdges)
            }
        }
        setNode(n => ({ ...n, data: { ...n?.data, [e.target.name]: value } }))
    }

    const handleSelectChange = ({ target: { value, name } }) => {
        if (name == 'type') setNode(n => ({ ...n, [name]: value, data: { ...n?.data, [name]: value } }))
        else setNode(n => ({ ...n, data: { ...n?.data, [name]: value } }))
    }

    const handleOptions = (type, { keyName, itemKeyName } = {}) => (e) => {
        e?.stopPropagation()
        switch (type) {
            case 'c':
                setOpenCreateOptionDialog(true)
                // setNode(n => {
                //     console.log('node', n)
                //     if (!n?.data?.answerOptionList) return { ...n, data: { ...n?.data, answerOptionList: [{ id: `opt_${Date.now()}`, label: '', value: '' }] } }
                //     if (n?.data?.answerOptionList?.filter(op => op?.value == '')[0]) return n;
                //     return { ...n, data: { ...n?.data, answerOptionList: [...n?.data?.answerOptionList, { id: `opt_${Date.now()}`, label: '', value: '' }] } }
                // })
                break;
            case 'd':
                setNode(n => ({ ...n, data: { ...n?.data, [keyName]: n?.data?.[keyName]?.filter((op) => op?.key == itemKeyName ? false : true) } }))
                setEdges(e => e?.filter(i => i?.sourceHandle !== itemKeyName))
                break;
            default:
                setNode(n => n)
                break;
        }
    }

    const handleCreateOption = () => {
        if (!createOptionData.key) {
            setErrMsg('empty key, please input again')
            return
        }
        if (node && node?.data?.['answerOptionList'] && node?.data?.['answerOptionList']?.map(i => i?.key).includes(createOptionData.key)) {
            setErrMsg('repeated key, please input again')
            return
        }
        setErrMsg('')
        setNode(n => ({ ...n, data: { ...n?.data, 'answerOptionList': n?.data?.['answerOptionList'] ? [...n?.data?.['answerOptionList'], createOptionData] : [createOptionData] } }))
        setOpenCreateOptionDialog(false)
        setCreateOptionData(d => ({ ...d, key: '' }))
    }


    const handleDragOptions = (source, destination) => {
        if (source?.droppableId === destination?.droppableId && source?.droppableId === node?.id) {
            const answerOptionList = node?.data?.answerOptionList || []
            if (answerOptionList) {
                [answerOptionList[source?.index], answerOptionList[destination?.index]] = [answerOptionList[destination?.index], answerOptionList[source?.index]]
            }

            // START，fix the issue of Handle unchange when drag options
            setNode(n => ({
                ...n, data: {
                    ...n?.data, 'answerOptionList': [...answerOptionList, {
                        key: '',
                        value: {
                            'EN': '',
                            'ZH_CN': '',
                            'ZH_HK': ''
                        }
                    }]
                }
            }))

            setTimeout(() => {
                setNode(n => ({
                    ...n, data: {
                        ...n?.data, 'answerOptionList': n?.data?.['answerOptionList']?.filter(i => i?.key !== '')
                    }
                }))
            }, 100);
            // END
        }
    }

    useEffect(() => {
        flowContainer.current = document.querySelector('.content-main-with-menu')
    }, [])

    useEffect(() => {
        if (node) updateNode(node?.id, node)

        // const newSaved = {
        //     ...savedSurveyFlow,
        //     questionList: savedSurveyFlow?.questionList ? savedSurveyFlow?.questionList?.map(
        //         el => el?.id == node?.id ? node?.data : el
        //     ) : null
        // }

        // dispatch(setSurveyFlow(newSaved))
    }, [node])

    const renderContent = () => {
        switch (node?.type) {
            case NODE_TYPES.TEXT_FIELD:
                return <SbcTextfield
                    data={node?.data}
                    handleIptChange={handleInputChange}
                    handleSwitchChange={handleSwitchChange}
                    handleSelectChange={handleSelectChange}
                    handleMultiIptChange={handleMultiInputChange}
                />
            case NODE_TYPES.DROPDOWN:
                return <SbcDropdown
                    data={node?.data}
                    handleIptChange={handleInputChange}
                    handleOptions={handleOptions}
                    handleSwitchChange={handleSwitchChange}
                    handleSelectChange={handleSelectChange}
                    handleMultiIptChange={handleMultiInputChange}
                    handleDragOptions={handleDragOptions}
                />
            case NODE_TYPES.CALENDAR:
                return <SbcCalendar
                    data={node?.data}
                    handleIptChange={handleInputChange}
                    handleOptions={handleOptions}
                    handleSwitchChange={handleSwitchChange}
                    handleSelectChange={handleSelectChange}
                    handleMultiIptChange={handleMultiInputChange}
                />
            case NODE_TYPES.RADIO:
                return <SbcRadio
                    data={node?.data}
                    handleIptChange={handleInputChange}
                    handleOptions={handleOptions}
                    handleSwitchChange={handleSwitchChange}
                    handleSelectChange={handleSelectChange}
                    handleMultiIptChange={handleMultiInputChange}
                    handleDragOptions={handleDragOptions}
                />
            case NODE_TYPES.CHECKBOX:
                return <SbcCheckbox
                    data={node?.data}
                    handleIptChange={handleInputChange}
                    handleOptions={handleOptions}
                    handleSwitchChange={handleSwitchChange}
                    handleSelectChange={handleSelectChange}
                    handleMultiIptChange={handleMultiInputChange}
                    handleDragOptions={handleDragOptions}
                />
            case NODE_TYPES.TEXT_AREA:
                return <SbcTextfield
                    data={node?.data}
                    handleIptChange={handleInputChange}
                    handleOptions={handleOptions}
                    handleSwitchChange={handleSwitchChange}
                    handleSelectChange={handleSelectChange}
                    handleMultiIptChange={handleMultiInputChange}
                />
            case NODE_TYPES.RATING:
                return <SbcRating
                    data={node?.data}
                    handleIptChange={handleInputChange}
                    handleOptions={handleOptions}
                    handleSwitchChange={handleSwitchChange}
                    handleSelectChange={handleSelectChange}
                    handleMultiIptChange={handleMultiInputChange}
                />
            case NODE_TYPES.IMAGELIST:
                return <SbcImagelist
                    data={node?.data}
                    handleIptChange={handleInputChange}
                    handleOptions={handleOptions}
                    handleSwitchChange={handleSwitchChange}
                    handleSelectChange={handleSelectChange}
                    handleMultiIptChange={handleMultiInputChange}
                />
            case NODE_TYPES.DROPDOWN_TEXT_FIELD:
                return <SbcDropdownTextfield
                    data={node?.data}
                    handleIptChange={handleInputChange}
                    handleOptions={handleOptions}
                    handleSwitchChange={handleSwitchChange}
                    handleSelectChange={handleSelectChange}
                    handleMultiIptChange={handleMultiInputChange}
                    handleDragOptions={handleDragOptions}
                />
            default:
                return null
        }
    }

    return (
        <div className='sidebar' style={{ display: open ? 'block' : 'none', position: 'absolute', top: 0, bottom: 0, overflow: 'auto' }}>
            {renderContent()}

            {/* create option dialog */}
            <SharedDialog
                maxWidth='md'
                open={openCreateOptionDialog}
                onClose={() => setOpenCreateOptionDialog(false)}
                title={'Create New Option'}
                content={
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <TextField
                                variant='filled'
                                type='text'
                                label='key'
                                name='key'
                                color='success'
                                error={errMsg ? true : false}
                                helperText={errMsg}
                                sx={{ width: '100%' }}
                                onChange={(e) => setCreateOptionData(p => ({ ...p, [e.target.name]: e.target.value }))}
                            />
                        </Grid>
                        {LANGS.map(key => (
                            <Grid key={key} item xs={4}>
                                <TextField
                                    variant='filled'
                                    type='text'
                                    label={key}
                                    name={key}
                                    color='success'
                                    sx={{ width: '100%' }}
                                    onChange={(e) => setCreateOptionData(p => ({ ...p, value: { ...p.value, [e.target.name]: e.target.value } }))}
                                />
                            </Grid>
                        ))}
                    </Grid>
                }
                actions={
                    <Stack direction={'row'} gap={1}>
                        <Button variant='outlined' onClick={() => setOpenCreateOptionDialog(false)}>Cancel</Button>
                        <Button variant='contained' onClick={handleCreateOption}>Create</Button>
                    </Stack>
                }
            />
        </div>
    )
}
